export const MessageBoxTestIdFactory = {
    // bases
    getMessageBoxBase: () => 'message-box',
    // for test id generation
    getMessageBoxTestId: (testId) => [MessageBoxTestIdFactory.getMessageBoxBase(), testId].join('-'),
};
